import { TableEdit, TableSelect } from "../components/AgComponents"
import { useSnapshot } from "valtio"
import { useEffect, useState } from "react"
import {
    quoteDataRec, airChargesStore, cargoStore, configStore, entityStore, EntityV2Store
} from '../state/CommonState'

import Utils from "../util/Utils"
import { chargesValidationStore } from "../state/validation-stores"
import chargedetails from "../assets/images/chargedetails.svg";
import { Card } from "../v3-componets/AgCard"
import { Headspan } from "../v3-componets/AgHeadspan"
import { TableLabel } from "../v3-componets/AgTableLabel"

export default function AirChargesCompv3(props) {
    const [grandTotal, setGrandTotal] = useState(0.0)
    const [shipTotal, setShipTotal] = useState(0.0)
    const [conTotal, setConTotal] = useState(0.0)
    const [onaccount, setonaccount] = useState(['On Your Account'])
    useSnapshot(quoteDataRec)
    console.log('ChargesComp rendering')
    let [space, setSpace] = useState('')

    useSnapshot(entityStore)
    let key = "list"
    if(props.keylist!=undefined){
        key = props.keylist
    }
    let initialLength = "initialLength"+key.replace("list","")
    let imChargesStore = useSnapshot(airChargesStore)


    useEffect(() => {
        let list = airChargesStore[key]
        for (let i = 0; i < list.length; i++) {
            if (!list[i].onaccount || !list[i].onaccount.length) list[i].onaccount = 'On Your Account'
        }
        if(!grandTotal){
            calculateFinalTotal()
        }
    }, [imChargesStore])
    useEffect(() => {
        let entity = EntityV2Store.list.find((e) => e.entityId === quoteDataRec.entityId)
        if (entity) {
            let sscope = quoteDataRec.shipmentScope
            sscope = sscope.toLowerCase()
            let country = '' + entity.entityCountry
            country = country.toLowerCase()
            let cecisorigin = false
            let cecisdestination = false
            let por = ('' + quoteDataRec.portOfLoading).toLowerCase()
            let pod = ('' + quoteDataRec.finalPlaceOfDelivery).toLowerCase()
            let q = quoteDataRec
            if(entity._id == "TBA" && q.isfromAgragaEnquiry != undefined && q.isfromAgragaEnquiry=='Yes' && q.countryFromEnquiry != undefined){
                country = q.countryFromEnquiry.toLowerCase()
            }
            if(country.includes('hong kong')){
                cecisorigin = por.includes('hong kong')
                cecisdestination = pod.includes('hong kong')
            }else {
                cecisorigin = por.includes(country)
                cecisdestination = pod.includes(country)
            }
            if (cecisorigin && sscope.endsWith('port')) setonaccount(['On Your Account', `Consignee's Account`])
            else if (cecisdestination && sscope.startsWith('port')) setonaccount(['On Your Account', `Shipper's Account`])
            else setonaccount(['On Your Account'])
            airChargesStore[key].map((e, i) => {
                if(sscope.length!=0 && country.length!=0 && por.length!=0 && pod.length!=0){
                    if(e.onaccount!=undefined){
                        if (cecisorigin && sscope.endsWith('port')){
                            if(['On Your Account', `Consignee's Account`].indexOf(e.onaccount)==-1){
                                e.onaccount = "On Your Account"
                            }
                        }else if (cecisdestination && sscope.startsWith('port')){
                            if(['On Your Account', `Shipper's Account`].indexOf(e.onaccount)==-1){
                                e.onaccount = "On Your Account"
                            }
                        }else{
                            e.onaccount = "On Your Account"
                        }
                    }
                }
                return e
            })
        }
        console.log('DETECTED CHANGES=', quoteDataRec.entityId, quoteDataRec.portOfReceipt, quoteDataRec.portOfDischarge)
    }, [
        quoteDataRec.entity,quoteDataRec.entityId, quoteDataRec.portOfLoading,
        quoteDataRec.portOfDischarge, quoteDataRec.shipmentScope
    ])
    const deleteRec = (id) => {
        //if (id <= imChargesStore[initialLength]) return
        const index = airChargesStore[key].findIndex(e => e.id === id)
        let records = airChargesStore[key]
        records = [...records]
        records.splice(index, 1)
        for (let i = 0; i < records.length; i++) {
            records[i].id = i + 1
        }
        if(id<=airChargesStore[initialLength]){
            airChargesStore[initialLength]=airChargesStore[initialLength]-1
        }
        airChargesStore[key] = records
        if(airChargesStore[key].length==0){
            let obj = imChargesStore.newRec
            obj = { ...obj }
            airChargesStore[key].push({ ...obj, id: airChargesStore[key].length + 1 })
        }
    }
    const Ts = ({ i, name, dataList }) => <TableSelect
        record={airChargesStore[key][i]} name={name} dataList={dataList} isValid={chargesValidationStore.isValidCharge(name, i,key)} />
    const Te = ({ i, name }) => {
        const e = airChargesStore[key][i]
        if (name === 'chargeDescription' && i < airChargesStore[initialLength])
            return <TableLabel record={airChargesStore[key][i]} name={name} />
        return (
            <TableEdit record={airChargesStore[key][i]} name={name} isValid={chargesValidationStore.isValidCharge(name, i,key)}/>
        )
    }
    const Tn = ({ i, name }) => {
        const e = airChargesStore[key][i]
        if (e.disabled && e.disabled.indexOf(name) >= 0)
            return (
                <input disabled='true' style={{ backgroundColor: '#dddddd', border: 'none' }} />
            )
        else return (
            <TableEdit record={airChargesStore[key][i]} name={name} type='number' isValid={chargesValidationStore.isValidCharge(name, i,key)} />
        )
    }

    const ifNotFCL = () => quoteDataRec.shipmentType.indexOf('FCL') < 0

    let finalTotal = 0.0
    const calculateFinalTotal = () => {
        let tot = 0
        let shiptot = 0
        let contot = 0
        airChargesStore[key].map((e) => {
            let erate = configStore.getExchangeRateinr(e)
            if (!erate || erate === 0) erate = 1.0
            if (e.onaccount && e.onaccount.startsWith('Cons')) contot += e.total * erate
            else if (e.onaccount && e.onaccount.startsWith('Ship')) shiptot += e.total * erate
            else {
                tot += e.total * erate
            }
        })
        if(tot){
            setGrandTotal(tot)
            setShipTotal(shiptot)
            setConTotal(contot)
        }
        return finalTotal
    }

    return (
        <>
            <hr />
            <Card  onClick={(e) => {
                e.nativeEvent.preventDefault()
                e.preventDefault()
                e.nativeEvent.stopPropagation()
                e.stopPropagation()

            }} >
                                    <span><img src={chargedetails}/></span><Headspan color="#00000" fontSize= "14px" fontWeight="900" data={" Charge Details"+(props.heading!=undefined && props.heading.length>0?" - "+props.heading:"")}/>
                                    <div className="table-container"  onClick={(e) => {
                e.nativeEvent.preventDefault()
                e.preventDefault()
                e.nativeEvent.stopPropagation()
                e.stopPropagation()

            }} >
                                    <table style={{border:"none", width:"100%"}}>
                                    <thead>
                        
                        {ifNotFCL() ?
                            <tr>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th colSpan='2' style={{border:"solid 0.5px #4BA7DD", backgroundColor:"#4BA7DD", color:"#fff",fontWeight:"900", padding:"10px", textAlign:"center"}} >Per Unit</th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr> : <></>
                        }
                        <tr style={{ fontWeight:"900",border:"solid 0.5px #D4D4D4"}}>
                                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>ID</th>
                                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px",width: '20rem' }}>Charge Description</th>
                                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>On Account</th>
                                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Currency</th>
                                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'center' }}>Per Kg</th>
                                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'center' }}>Minimum</th>
                                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'center' }}>Per AWB</th>
                                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right' }}>Total</th>
                                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'center' }}>Action</th>
                            </tr>
                    </thead>
                    <tbody>
                    {
                            imChargesStore[key].map((e, i) => {
                                {
                                    return <tr key={e.id} style={{border:"solid 0.5px #D4D4D4", backgroundColor:(i%2)==1?"#F3F3F3":"none"}}>
                                        <td style={{color:"#555555", padding:"10px"}}>{e.id}</td>
                                        <td style={{color:"#555555", padding:"10px"}}><Te i={i} name='chargeDescription' /></td>
                                        <td style={{color:"#555555", padding:"10px"}}><Ts i={i} name='onaccount' dataList={onaccount} /></td>
                                        <td style={{color:"#555555", padding:"10px"}}><Ts i={i} name='currency' dataList={configStore.getCurrencyList()} /></td>
                                        <td style={{color:"#555555", padding:"10px", textAlign: 'center' }}><Tn i={i} name='perKg' /></td>
                                        <td style={{color:"#555555", padding:"10px", textAlign: 'center' }}><Tn i={i} name='minimum' /></td>
                                        <td style={{color:"#555555", padding:"10px", textAlign: 'center' }}><Tn i={i} name='perAWB' /></td>
                                        <td style={{ color:"#555555", padding:"10px",textAlign: 'right' }}>{
                                            (e.total > 0 && e.currency != '') ? Utils.N(e.total, e.currency) : ''
                                        }</td>
                                        <td style={{color:"#555555", padding:"10px", textAlign: 'center' }}>
                                            <div className="field has-addons">
                                                
                                                        <p className="control">
                                                            <button className="button is-danger is-inverted"
                                                                onClick={() => {
                                                                    deleteRec(e.id)
                                                                    setSpace(space === '' ? ' ' : '')
                                                                }}>
                                                                <span className="icon">
                                                                    <i className="fas fa-trash"></i>
                                                                </span>
                                                            </button>
                                                        </p>
                                               
                                                {
                                                    i === imChargesStore[key].length - 1 &&
                                                    (
                                                        <p className="control">
                                                            <button className="button is-success is-inverted"
                                                                onClick={() => {
                                                                    let obj = imChargesStore.newRec
                                                                    obj = { ...obj }
                                                                    airChargesStore[key].push({ ...obj, id: imChargesStore[key].length + 1 })
                                                                    setSpace(space === '' ? ' ' : '')
                                                                }}>
                                                                <span className="icon is-small">
                                                                    <i className="fas fa-plus"></i>
                                                                </span>
                                                            </button>
                                                        </p>
                                                    )
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                }
                            }
                            )
                        }
                        <tr style={{border:"solid 0.5px #D4D4D4"}}>
                            <td colSpan={7} style={{ textAlign: 'right',color:"#555555", padding:"10px", fontWeight:"900"}}>Total of On Your Account : </td>
                            <td style={{ color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right', fontSize: '1.1rem', fontWeight:"900"}}><strong>{Utils.N(grandTotal)}</strong></td>
                            <td rowSpan={(conTotal && shipTotal)?4:(conTotal || shipTotal)?3:2} style={{ textAlign: 'center' }}>
                            <button className="button is-info is-inverted"
                                                        
                                                        onClick={(e) => {
                                                            e.nativeEvent.preventDefault()
                                                            e.preventDefault()
                                                            e.nativeEvent.stopPropagation()
                                                            e.stopPropagation()
                                            
                                                            cargoStore.calculateCargoTotals()
                                    airChargesStore.calculateChargesTotalsindex(key)
                                    calculateFinalTotal()
                                    setSpace(space === '' ? ' ' : '')
                                                        }}>
                                                        <span className="icon is-small">
                                                            <i className="fas fa-calculator"></i>
                                                        </span>
                                                    </button>
                            </td>
                        </tr>
                        {
                            shipTotal > 0 &&
                            <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td colSpan={7} style={{ textAlign: 'right',color:"#555555", padding:"10px", fontWeight:"900"}}>Total of On Shipper's Account : </td>
                                <td  style={{ color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right', fontSize: '1.1rem', fontWeight:"900"}}><strong>{Utils.N(shipTotal)}</strong></td>
                            </tr>
                        }
                        {
                            conTotal > 0 &&
                            <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td colSpan={7} style={{ textAlign: 'right',color:"#555555", padding:"10px", fontWeight:"900"}}>Total of On Consignee's Account : </td>
                                <td  style={{ color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right', fontSize: '1.1rem', fontWeight:"900"}}><strong>{Utils.N(conTotal)}</strong></td>
                            </tr>
                        }
                    </tbody>
                                    </table></div></Card>
        </>
    )
}
